import { render } from "./IconLegend.vue?vue&type=template&id=8f5c1482"
import script from "./IconLegend.vue?vue&type=script&lang=js"
export * from "./IconLegend.vue?vue&type=script&lang=js"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__